<template>
    <div class="Scenes" id="application">

        <div class="cloud_service">
            <div class="content">
                <div class="cloud_title">
                    更专业的企业云电脑
                </div>
                <div class="cloud_list">
                    <div v-for="(item, index) in copywritingydj" :key="index" class="cloud-item"
                        :class="index !== 0 ? 'cloud_li0' : 'cloud_li1'">
                        <h3 class="cloud-item-title">{{ item.title }}</h3>
                        <p class="cloud-item-desc">{{ item.desc }}</p>
                        <img class="cloud-item-img" :src="item.icon" />
                        <div class="text_list">
                            <div class="text_list_content" v-for="(text_item, inx) in item.text" :key="inx"
                                :class="inx % 2 === 0 ? 'text_0' : 'text_1'">
                                <img class="text-item-img" :src="item.text_iocn" />
                                <p class="text-item-text">{{ text_item }}</p>
                            </div>
                        </div>
                        <a target="_blank" :href="`https://pc.todesk.com/contact${index !== 0 ? '' : 1}`"
                            :id="index !== 0 ? 'daas_buy_tob_pri_btn' : 'daas_buy_tob_bat_btn'">
                            咨询客户经理
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="ydj_big">
            <div class="pay">
                <div class="pay_title1">操作简便 轻松上云</div>
                <div class="pay_title2">计费灵活，操作简单，如「本地电脑般」流畅</div>
                <div class="pay_title">
                    <div class="pay_title3">
                        <div class="contain1">
                            <img class="img1" src="@/assets/desktron/ydj1.png" alt="" />
                            <div class="tip">下载安装</div>
                        </div>
                        <div class="contain2">
                            <img src="@/assets/desktron/ydj4.png" alt="" />
                        </div>
                        <div class="contain1 addPrice">
                            <img class="img2" src="@/assets/desktron/ydj2.png" alt="" />
                            <div class="tip">添加购买桌面</div>
                        </div>
                        <div class="contain2">
                            <img src="@/assets/desktron/ydj4.png" alt="" />
                        </div>
                        <div class="contain1">
                            <img class="img3" src="@/assets/desktron/ydj3.png" alt="" />
                            <div class="tip">开机使用</div>
                        </div>
                    </div>
                    <div class="pay_title4">
                        <a class="btn-common btn-primary addMask" :href="`${_daas_www_hostName}/download`"
                            id="daas_buy_gd_dl_btn" target="_blank">
                            立即下载
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qr1 from "@/assets/desktron/Scenes/qr1.png";
import qr2 from "@/assets/desktron/Scenes/qr2.png";
import tick_purple from "@/assets/desktron/Scenes/tick_purple.png";
import tick_blue from "@/assets/desktron/Scenes/tick_blue.png";
export default {
    components: {
    },
    props: {
        path: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            copywritingydj: [
                {
                    icon: qr2,
                    title: "中小企业专属",
                    desc: '根据不同业务需求，提供高性价比高配置的云电脑',
                    text: [
                        '节省设备采购成本',
                        '一键部署快速响应',
                        '支持多种办公软件',
                        '随时随地进行办公'
                    ],
                    text_iocn: tick_blue,
                },
                {
                    icon: qr1,
                    title: "私有化部署",
                    desc:'根据不同使用场景，提供专业化的定制方案',
                    text:[
                        '极致高清流畅体验',
                        '特定场景专属定制',
                        '运维管理简单高效',
                        '多种传输策略兼顾安全与性能'
                    ],
                    text_iocn: tick_purple,
                },
            ],
        };
    },
    methods: {
    },
};
</script>
<style lang="less" scoped>
.btn-common {
    box-sizing: border-box;
    width: 132px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid rgba(105,116,167,.22);
    background: #fff;
    color: #0c89e4;
    text-align: center;
    line-height: 40px; 
    font-size: 14px;
    cursor: pointer;
    transition: background-color .2s;
}
.btn-primary { 
    background-color: #11BBF2;
    color: #fff;
    border-color: #11BBF2;
    &:hover {
        opacity: 0.7;
    }
    &:active {
        opacity: 0.9;
    }
}

.cloud_service {
    background: #ffffff;
    width: 100%;
    padding: 16px 0px 16px 0px;
    height: max-content;
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .cloud_title {
        font-size: 28px;
        font-weight: bold;
        line-height: 40px;
        margin-bottom: 38px;
    }

    .cloud_list {
        // display: flex;
        width: 100%;
        background: #FFFFFF;
        .cloud-item {
            width: 328px;
            border: 1px solid #0000001A;
            box-sizing: border-box;
            border-radius: 4px;
            align-items: center;
            padding: 24px 8px;
            box-shadow: 0px 3.4px 8px 0px #0000001A, 0px 1px 2px 0px #FFFFFF80;
            margin: 0 auto;

            &.cloud_li0 {
                margin-top: 24px;
                border-top: 8px solid #6B4DBF;
                margin-bottom: 24px;
                a {
                    display: block;
                    margin: auto;
                    border: 1px solid #7B54E9;
                    color: #774FE8;
                    border-radius: 4px;
                    height: 50px;
                    width: 210px;
                    text-align: center;
                    line-height: 50px;
                    font-weight: 500;
                    cursor: pointer;
                    font-size: 16px;

                    &:hover {
                        background: #F1EDFD;
                    }
                }
            }

            &.cloud_li1 {
                border-top: 8px solid #0C85AC;

                a {
                    display: block;
                    margin: auto;
                    border: 1px solid #00A4DD;
                    color: #00A4DD;
                    border-radius: 4px;
                    height: 50px;
                    width: 210px;
                    text-align: center;
                    line-height: 50px;
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: 500;

                    &:hover {
                        background: #E7F8FE;
                    }
                }
            }

            .cloud-item-img {
                height: 132px;
                width: 132px;
                margin:14px auto 0px auto;
                display: block;
            }

            .cloud-item-title {
                font-size: 24px;
                color: #000405;
                font-weight: bold;
                text-align: center;
            }

            .cloud-item-desc {
                font-size: 14px;
                line-height: 20px;
                margin-top: 12px;
                color: #00000080;
                text-align: center;
            }

            .text_list {
                padding: 20px 30px;

                .text_list_content {
                    width: 100%;
                    display: flex;
                    display: flex;
                    height: 36px;
                    align-items: center;
                    .text-item-img {
                        height: 18px;
                        width: 18px;
                        margin-right: 8px;
                    }

                    .text-item-text {
                        font-size: 14px;
                        color: #000405;
                    }
                }
            }
        }
    }
}

.ydj_big {
    width: 100%;
    padding: 40px 0px;
    min-height: 248px;
    height: max-content;
    background: #F5F7F8;
    .pay {
        display: flex;
        flex-direction: column;
        align-items: center;
        .pay_title1 {
            font-size: 28px;
            font-weight: bold;
            color: #000405;
            line-height: 40px;
            text-align: center;
        }
        .pay_title2 {
            font-size: 14px;
            color: #40484B;
            line-height: 20px;
            text-align: center;
            margin-top: 8px;
        }
        .pay_title {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 28px auto 0 auto;
        }
        .pay_title3 {
            margin-bottom: 28px;
            height: 84px;
            display: flex;
            .contain1 {
                width: 72px;
                display: flex;
                flex-direction: column;
                align-items: center;
                font-size: 14px;
                color: #232729;
                &.addPrice{
                    width: 100px;
                }
                img {
                    height: 36px;
                    margin-bottom: 10px;
                    margin-top: 10px;
                    &.img2{
                    }
                    &.img3{
                    }
                }
            }
            .contain2 {
                width: 40px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img {
                    width: 40px;
                    height: 32px;
                }
            }
        }
        .pay_title4 {
            display: flex;
            .btn-common {
                width: 160px;
                height: 47px;
                line-height: 46px;
                position: relative;
                font-size: 16px;
            }
        }
    }
}

.charge_mode {
    background: #ffffff;
    padding-top: 0px;
    padding-bottom: 37px;
    width: 100%;
    height: max-content;
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .charge_mode_title {
            display: flex;
            align-items: center;
            cursor: pointer;

            span {
                font-size: 18px;
                line-height: 28px;
                margin-left: 6px;
            }

            .charge_mode_back {
                width: 24px;
                height: 24px;
                margin-left: 6px;
                background-image: url(~@/assets/desktron/Scenes/charge_mode1.png);
                background-size: cover;
            }

            .tick {
                background-image: url(~@/assets/desktron/Scenes/charge_mode2.png);
            }

        }

        .charge_mode_desc {
            background: #F5F7F8;
            border-radius: 8px;
            width: 328px;
            margin-top: 24px;

            .charge_mode_item {
                padding: 24px 26px;
                img {
                    height: 50px;
                    width: 50px;
                }

                .charge_mode_p1 {
                    color: #000405;
                    font-size: 22px;
                    line-height: 22px;
                    font-weight: bold;
                    margin-top: 12px;
                }

                .charge_mode_p2 {
                    margin-top: 14px;
                    color: #383E42;
                    font-size: 14px;
                    line-height: 20px;
                }
            }

            .charge_mode_link {
                height: 1px;
                background: #0000001A;
                margin: 0px 26px;
            }
        }
    }
}
</style>